"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedDollarParameter_1 = require("./IndexedDollarParameter");
var MemberType_1 = require("./MemberType");
var AccountType_1 = require("./AccountType");
var _2013_6_30 = new Date(2013, 5, 30, 12, 0, 0).getTime();
var _2014_6_30 = new Date(2014, 5, 30, 12, 0, 0).getTime();
var _2021_6_30 = new Date(2021, 5, 30, 12, 0, 0).getTime();
var _2022_6_30 = new Date(2022, 5, 30, 12, 0, 0).getTime();
var _2023_6_30 = new Date(2023, 5, 30, 12, 0, 0).getTime();
var _2024_6_30 = new Date(2024, 5, 30, 12, 0, 0).getTime();
var _2025_6_30 = new Date(2025, 5, 30, 12, 0, 0).getTime();
var Insurance = (function () {
    function Insurance() {
        this._insurancePremium = null;
        this._qsuperDeathTPDDefault = [];
        this._qsuperDeathTPDPolice = [];
        this._qsuperUnitsCoverGovernment = 0;
        this._qsuperUnitsCoverNonGovernment = 0;
        this._ipInsuranceGovernmentEmployee = [];
        this._ipInsurancePoliceEmployee = [];
        this._sunSuperDeathTPDMale = [];
        this._sunSuperDeathTPDFemale = [];
        this._fssInsurancePremium = null;
        this._visionDeathAndTPD = null;
        this._visionIncomeProtection = [];
        this._visionIPSalaryThreshold = null;
    }
    Insurance.prototype.initialise = function (p, indexationBasis, salary, age, equipInitialPremium) {
        this._insurancePremium = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._insurancePremium.initialise(p.getParamNumber("InsurancePremium"), indexationBasis);
        this._incomeProtectionInsurancePremium = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._incomeProtectionInsurancePremium.initialise(p.getParamNumber("IncomeProtectionInsurancePremium"), indexationBasis);
        this._visionDeathAndTPD = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._visionDeathAndTPD.initialise(p.getParamNumber("VisionTPD"), indexationBasis);
        this._visionIPSalaryThreshold = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._visionIPSalaryThreshold.initialise(p.getParamNumber("VisionIPSalaryThreshold"), indexationBasis);
        this._fssInsurancePremium = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._fssInsurancePremium.initialise(p.getParamNumber("FSSInsurancePremium"), indexationBasis);
        this._ActiveSuper_MaleDeathPerUnitPerMonth = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._ActiveSuper_MaleDeathPerUnitPerMonth.initialise(p.getParamNumber("ActiveSuper_MaleDeathPerUnitPerMonth"), indexationBasis);
        this._ActiveSuper_FemaleDeathPerUnitPerMonth = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._ActiveSuper_FemaleDeathPerUnitPerMonth.initialise(p.getParamNumber("ActiveSuper_FemaleDeathPerUnitPerMonth"), indexationBasis);
        this._ActiveSuper_MaleTPDPerUnitPerMonth = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._ActiveSuper_MaleTPDPerUnitPerMonth.initialise(p.getParamNumber("ActiveSuper_MaleTPDPerUnitPerMonth"), indexationBasis);
        this._ActiveSuper_FemaleTPDPerUnitPerMonth = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._ActiveSuper_FemaleTPDPerUnitPerMonth.initialise(p.getParamNumber("ActiveSuper_FemaleTPDPerUnitPerMonth"), indexationBasis);
        var governmentIncomeProtection;
        var policeIncomeProtection;
        var qsuperDeathTPDDefault;
        var qsuperDeathTPDPolice;
        var sunSuperDeathTPDMale;
        var sunSuperDeathTPDFemale;
        var visionIncomeProtection;
        governmentIncomeProtection = p.getParamObject("GovernmentIncomeProtectionTable");
        policeIncomeProtection = p.getParamObject("PoliceIncomeProtectionTable");
        qsuperDeathTPDDefault = p.getParamObject("QSuperDeathTPDDefault");
        qsuperDeathTPDPolice = p.getParamObject("QSuperDeathTPDPolice");
        sunSuperDeathTPDMale = p.getParamObject("SunSuperDeathTPDMale");
        sunSuperDeathTPDFemale = p.getParamObject("SunSuperDeathTPDFemale");
        visionIncomeProtection = p.getParamObject("VisionIncomeProtection");
        for (var counter_1 = 16; counter_1 <= 65; counter_1++) {
            this._ipInsuranceGovernmentEmployee[counter_1 - 1] = governmentIncomeProtection.cost(counter_1);
            this._visionIncomeProtection[counter_1 - 1] = new IndexedDollarParameter_1.IndexedDollarParameter();
            this._visionIncomeProtection[counter_1 - 1].initialise(visionIncomeProtection.cost(counter_1), indexationBasis);
        }
        for (var counter_2 = 16; counter_2 <= 60; counter_2++) {
            this._ipInsurancePoliceEmployee[counter_2 - 1] = policeIncomeProtection.cost(counter_2);
        }
        for (var counter_3 = 15; counter_3 <= 69; counter_3++) {
            this._sunSuperDeathTPDMale[counter_3 - 1] = new IndexedDollarParameter_1.IndexedDollarParameter();
            this._sunSuperDeathTPDFemale[counter_3 - 1] = new IndexedDollarParameter_1.IndexedDollarParameter();
            this._sunSuperDeathTPDMale[counter_3 - 1].initialise(sunSuperDeathTPDMale.cost(counter_3), indexationBasis);
            this._sunSuperDeathTPDFemale[counter_3 - 1].initialise(sunSuperDeathTPDFemale.cost(counter_3), indexationBasis);
        }
        for (var counter_4 = 16; counter_4 <= 69; counter_4++) {
            this._qsuperDeathTPDDefault[counter_4 - 1] = new IndexedDollarParameter_1.IndexedDollarParameter();
            this._qsuperDeathTPDDefault[counter_4 - 1].initialise(qsuperDeathTPDDefault.cost(counter_4), indexationBasis);
        }
        for (var counter_5 = 16; counter_5 <= 59; counter_5++) {
            this._qsuperDeathTPDPolice[counter_5 - 1] = new IndexedDollarParameter_1.IndexedDollarParameter();
            this._qsuperDeathTPDPolice[counter_5 - 1].initialise(qsuperDeathTPDPolice.cost(counter_5), indexationBasis);
        }
        this._qsuperUnitsCoverGovernment = p.getParamNumber("QSuperDefaultInsuranceUnitsGovernment");
        this._qsuperUnitsCoverNonGovernment = p.getParamNumber("QSuperDefaultInsuranceUnitsNonGovernment");
        this._equipSuperDeathAndTPD = new IndexedDollarParameter_1.IndexedDollarParameter();
        this._equipSuperDeathAndTPD.initialise(equipInitialPremium, indexationBasis);
        var equipInsurancePremiumSteps = p.getParamObject("EquipInsurancePremiumSteps");
        this._equipInsurancePremiumSteps = [];
        for (var counter = 17; counter <= 70; counter++) {
            this._equipInsurancePremiumSteps[counter] = equipInsurancePremiumSteps.cost(counter);
        }
        this._overrideFundDefaultPremiums = p.getParamBoolean("OverrideFundDefaultInsurancePremiums");
    };
    Insurance.prototype.index = function (year, age) {
        var equipAgeBasedPremiumStep;
        this._insurancePremium.index(year);
        this._incomeProtectionInsurancePremium.index(year);
        this._visionDeathAndTPD.index(year);
        this._fssInsurancePremium.index(year);
        this._ActiveSuper_MaleDeathPerUnitPerMonth.index(year);
        this._ActiveSuper_FemaleDeathPerUnitPerMonth.index(year);
        this._ActiveSuper_MaleTPDPerUnitPerMonth.index(year);
        this._ActiveSuper_FemaleTPDPerUnitPerMonth.index(year);
        for (var counter = 16; counter <= 69; counter++) {
            this._qsuperDeathTPDDefault[counter - 1].index(year);
        }
        for (var counter = 16; counter <= 59; counter++) {
            this._qsuperDeathTPDPolice[counter - 1].index(year);
        }
        this._visionIPSalaryThreshold.index(year);
        for (var counter = 16; counter <= 65; counter++) {
            this._visionIncomeProtection[counter - 1].index(year);
        }
        for (var counter = 15; counter <= 69; counter++) {
            this._sunSuperDeathTPDMale[counter - 1].index(year);
            this._sunSuperDeathTPDFemale[counter - 1].index(year);
        }
        age = age + 1;
        this._equipSuperDeathAndTPD.index(year);
        if (age < 17) {
            equipAgeBasedPremiumStep = this._equipInsurancePremiumSteps[17];
        }
        else if (age > 70) {
            equipAgeBasedPremiumStep = this._equipInsurancePremiumSteps[70];
        }
        else {
            equipAgeBasedPremiumStep = this._equipInsurancePremiumSteps[age];
        }
        this._equipSuperDeathAndTPD.resetValues(this._equipSuperDeathAndTPD.value * equipAgeBasedPremiumStep);
    };
    Insurance.prototype.getDeathAndTpdPremium = function (thisAccountType, thisMemberType, age, isRetired, sex) {
        var result = 0;
        if ((thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT
            || thisMemberType === MemberType_1.MemberType.QSUPER_NON_GOVERNMENT
            || thisMemberType === MemberType_1.MemberType.QSUPER_POLICE
            || thisMemberType === MemberType_1.MemberType.ART_DEFAULT
            || thisMemberType === MemberType_1.MemberType.ART_LIFECYCLE
            || thisMemberType === MemberType_1.MemberType.FIRSTSTATESUPER
            || thisMemberType === MemberType_1.MemberType.FIRSTSTATESUPER_MYSUPER
            || thisMemberType === MemberType_1.MemberType.VISION
            || thisMemberType === MemberType_1.MemberType.EQUIPSUPER
            || thisMemberType === MemberType_1.MemberType.ACTIVE_SUPER_LIFECYCLE
            || thisMemberType === MemberType_1.MemberType.ACTIVE_SUPER)
            && thisAccountType === AccountType_1.AccountType.ACCUMULATION
            && this._overrideFundDefaultPremiums == false) {
            if (thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT &&
                thisAccountType === AccountType_1.AccountType.ACCUMULATION) {
                if (isRetired === true || age >= 70) {
                    result = 0;
                }
                else {
                    result = this._qsuperDeathTPDDefault[age - 1].value * 52.18 * this._qsuperUnitsCoverGovernment;
                }
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_NON_GOVERNMENT &&
                thisAccountType === AccountType_1.AccountType.ACCUMULATION) {
                if (isRetired === true || age >= 70) {
                    result = 0;
                }
                else {
                    result = this._qsuperDeathTPDDefault[age - 1].value * 52.18 * this._qsuperUnitsCoverNonGovernment;
                }
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_POLICE &&
                thisAccountType === AccountType_1.AccountType.ACCUMULATION) {
                if (isRetired === true || age >= 60) {
                    result = 0;
                }
                else {
                    result = this._qsuperDeathTPDPolice[age - 1].value * 52.18 * this._qsuperUnitsCoverGovernment;
                }
            }
            else if (thisMemberType === MemberType_1.MemberType.ART_DEFAULT ||
                thisMemberType === MemberType_1.MemberType.ART_LIFECYCLE) {
                if (isRetired === true || age >= 70) {
                    result = 0;
                }
                else {
                    if (sex === "Male") {
                        result = this._sunSuperDeathTPDMale[age - 1].value * 52.18;
                    }
                    else {
                        result = this._sunSuperDeathTPDFemale[age - 1].value * 52.18;
                    }
                }
            }
            else if (thisMemberType === MemberType_1.MemberType.FIRSTSTATESUPER ||
                thisMemberType === MemberType_1.MemberType.FIRSTSTATESUPER_MYSUPER) {
                result = this._fssInsurancePremium.value;
            }
            else if (thisMemberType === MemberType_1.MemberType.VISION) {
                result = this._visionDeathAndTPD.value;
            }
            else if (thisMemberType === MemberType_1.MemberType.EQUIPSUPER) {
                if (isRetired) {
                    result = 0;
                }
                else {
                    result = this._equipSuperDeathAndTPD.value;
                }
            }
            else if (thisMemberType === MemberType_1.MemberType.ACTIVE_SUPER_LIFECYCLE ||
                thisMemberType === MemberType_1.MemberType.ACTIVE_SUPER) {
                var deathPremiumPerUnitPerMonth;
                var tpdPremiumPerUnitPerMonth;
                var deathUnits;
                var tpdUnits;
                if (age <= 25) {
                    deathUnits = 5;
                    tpdUnits = 15;
                }
                else if (age <= 30) {
                    deathUnits = 10;
                    tpdUnits = 10;
                }
                else if (age <= 70) {
                    deathUnits = 15;
                    tpdUnits = 5;
                }
                else {
                    deathUnits = 0;
                    tpdUnits = 0;
                }
                if (sex === "Male") {
                    deathPremiumPerUnitPerMonth = this._ActiveSuper_MaleDeathPerUnitPerMonth.value;
                    tpdPremiumPerUnitPerMonth = this._ActiveSuper_MaleTPDPerUnitPerMonth.value;
                }
                else {
                    deathPremiumPerUnitPerMonth = this._ActiveSuper_FemaleDeathPerUnitPerMonth.value;
                    tpdPremiumPerUnitPerMonth = this._ActiveSuper_FemaleTPDPerUnitPerMonth.value;
                }
                result = deathPremiumPerUnitPerMonth * 12 * deathUnits +
                    tpdPremiumPerUnitPerMonth * 12 * tpdUnits;
            }
            return result;
        }
        else {
            if (isRetired) {
                result = 0;
            }
            else {
                result = this._insurancePremium.value;
            }
            return result;
        }
    };
    Insurance.prototype.incomeProtectionPremium = function (thisAccountType, thisMemberType, age, isRetired, salary, projectionRunAsAt, yearCount) {
        if (isRetired === true ||
            age >= 65) {
            return 0;
        }
        else if (thisAccountType === AccountType_1.AccountType.ACCUMULATION &&
            this._overrideFundDefaultPremiums == true) {
            return this._incomeProtectionInsurancePremium.value;
        }
        else if (thisAccountType === AccountType_1.AccountType.ACCUMULATION &&
            (thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT ||
                thisMemberType === MemberType_1.MemberType.QSUPER_POLICE ||
                thisMemberType === MemberType_1.MemberType.VISION)) {
            if (thisMemberType === MemberType_1.MemberType.QSUPER_DEFAULT) {
                return this._ipInsuranceGovernmentEmployee[age - 1] * salary;
            }
            else if (thisMemberType === MemberType_1.MemberType.QSUPER_POLICE && age < 60) {
                return this._ipInsurancePoliceEmployee[age - 1] * salary;
            }
            else if (thisMemberType === MemberType_1.MemberType.VISION) {
                return Math.floor(salary * 0.75 / 12 / this._visionIPSalaryThreshold.value) * this._visionIncomeProtection[age - 1].value * 52.18;
            }
            else {
                return 0;
            }
        }
        else {
            return this._incomeProtectionInsurancePremium.value;
        }
    };
    return Insurance;
}());
exports.Insurance = Insurance;
//# sourceMappingURL=Insurance.js.map